export enum MatchType {
  /** Base match type (navmesh, walls, ants/towers with default behaviour). Others derive from this. */
  base = 'base',
  /** Outpost Run — wire / persisted value remains `trenchRun`. */
  outpostRuns = 'trenchRun',
  /** Zone Rush — wire / persisted value remains `captureMode`. */
  zoneRush = 'captureMode',
  terraforming = 'terraforming'
}

/**
 * Stable wire and map-config discriminator: enum **values**, not TS member names.
 * Map JSON uses these strings (`trenchRun`, `captureMode`, …); match-history and REST keep the same values.
 */
export type MatchTypeWire = `${MatchType}`;

export const isMatchType = (type: string): type is MatchType => Object.values(MatchType).includes(type as MatchType);
